/**
 * @Author ytyjm
 * @Create Time 2020/3/23
 * @Description: 所有接口请求
 */

// eslint-disable-next-line no-unused-vars
import { getRequest, postRequest } from './request'

/* 登录注册 */
// export const login = data => postRequest('/login', data)
// export const register = data => getRequest('/register', data)

// export const xxx = data => deleteRequest('/xxx', data)
// export const xxx = data => putRequest('/xxx', data)

/* 文章接口 */

export const getTaskList = data => postRequest('/task/list', data)



export const qryActivityInfo = data => postRequest('/activity/qryActivityInfo', data)

export const externalGetCoupon = data => postRequest('/activity/externalGetCoupon', data)
/**
 * 活动二
 */

/*获取活动二状态
* @desc:return status	String	0：未开始 1：已结束 2：活动中
* @return:{
    "data": {
        "status": 2
    },
    "respcod": "01",
    "respmsg": "活动中"
}
* */
export const getActStatus=data=>postRequest('/wallet/activity/status',data)

/**
 * 发短信
 * @param data
 * @returns {res.data}
 */
export const sendVerifyCode=data=>postRequest('/wallet/activity/sendVerifyCode',data)
/**
 * 支付
 * @param data
 * @returns {res.data}
 */
export const activityPay=data=>postRequest('/wallet/activity/pay',data)
/**
 * 5元话费充值
 * @param data
 * @returns {res.data}
 */
export const wangxin2Order=data=>postRequest('/wangxin/wangxin2Order',data)
/**
 *兑换码下单
 * @param data
 * @returns {res.data}
 */
export const requestCdkey=data=>postRequest('/wallet/activity/requestCdkey',data)





